import { createContext, useContext, useState, useEffect } from "react";
import { Navigate } from "react-router-dom";

interface AuthContextType {
    token: string | null;
    login: (newToken: string) => void;
    logout: () => void;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
    const [token, setToken] = useState<string | null>(localStorage.getItem("token") || null);

    // Save token to localStorage when it changes
    useEffect(() => {
        if (token) {
            localStorage.setItem("token", token);
        } else {
            localStorage.removeItem("token"); // Clear if token is null
        }
    }, [token]);

    // Login function to store token
    const login = (newToken: string) => {
        setToken(newToken);
        localStorage.setItem("token", newToken);
    };

    // Logout function to remove token
    const logout = () => {
        setToken(null);
        <Navigate to={`${process.env.PUBLIC_URL}/login`} />
    };

    return (
        <AuthContext.Provider value={{ token, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

// Custom hook for easy usage
export const useAuth = () => useContext(AuthContext);
